<template>
  <b-container
    id="app1"
    class="bv-example-row"
    fluid="true xl md sm xs"
    style="padding: 2rem 0rem"
  >
    <b-row class="justify-content-md-center">
      <p></p>
    </b-row>

    <b-row class="justify-content-md-center">
      <div v-if="!memberShow">
        <b-col>
          <img
            class="img-response"
            alt="高中職招生宣導資訊管理系統"
            src="Reports.png"
            style="float: center; width: 60%"
            title="高中職招生宣導資訊管理系統"
          />
          <br />
          <div
            class="form-group frame_title"
            style="text-align: center; font-size: 2em"
          >
            高中職招生宣導資訊管理系統
          </div>
          <div
          class="lab_td"
            style="text-align: center; font-size: 1em"
          >
          教師：請使用教師篇密碼<br>
          職員：請使用差勤系統密碼<br>
          </div>
          <div style="text-align: center">
            <form method="post" >
              <table
                cellspacing="0"
                style="width: 100%; border: 0; margin: 0 0 0.4em 0"
              >
                <tbody>
                  <tr>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td class="lab_td" style="width: 12rem">
                      {{ $t("message.ID_txt") }}
                      <b-icon icon="person"></b-icon>：&nbsp;
                    </td>
                    <td class="inp_td" colspan="2">
                      <b-form-input
                        placeholder="請輸入帳號"
                        maxlength="20"
                        style="width: 9.375rem"
                        v-model="user.id1"
                        :autofocus="true"
                        :clearable="true"
                      ></b-form-input>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="lab_td">
                      {{ $t("message.PassW_txt") }}
                      <b-icon icon="key"></b-icon>：&nbsp;
                    </td>
                    <td class="inp_td" colspan="2">
                      <b-form-input
                        type="password"
                        placeholder="請輸入密碼"
                        maxlength="20"
                        style="width: 9.375em"
                        v-model="user.id2"
                      ></b-form-input>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="lab_td">
                      {{ $t("message.ValiC_txt") }}
                      <b-icon icon="pencil"></b-icon>：&nbsp;
                    </td>
                    <td class="inp_td" style="width: 6.5rem">
                      <b-form-input
                        placeholder="請輸入驗證碼"
                        maxlength="6"
                        style="width: 6em"
                        v-model="user.id3"
                      ></b-form-input>
                    </td>
                    <td style="display: flex; padding: 0.3rem">
                      <img
                        v-if="captchaInfo != null"
                        :src="captchaInfo.text2"
                        style="margin: 0 0 0 0; height: 2.75rem"
                        alt=""
                      /><a
                        href="#"
                        style="padding: 0 0.6rem"
                        title="重新產生驗證碼"
                        @click.prevent="getCaptcha()"
                      >
                        <b-icon icon="bootstrap-reboot"></b-icon
                      ></a>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;&nbsp;</td>
                    <td>&nbsp;&nbsp;</td>
                    <td style="padding: 1em 0 0; text-align: center">
                      <b-button
                        variant="primary"
                        style="width: 6.5rem"
                        @click.prevent="login()"
                      >
                        {{ $t("message.Sign_in") }}
                        <b-icon icon="door-open" />
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        style="width: 6.5rem"
                        type="reset"
                        @click="onReset"
                        variant="danger"
                        >Reset</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>

        </b-col>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import * as tools from "../tool";
export default {
  name: "index",

  data() {
    return {
      memberShow: false,
      em: "",
      content: {
        text1: "",
        text2: "",
      },
      user: {
        id1: "",
        id2: "",
        id3: "",
        sysId: 0, // 學生登入
        isLogin: true,
      },

      // captchaInfo:{text1:'',text2:'',text3:''},
      confirmData: null,
      captchaInfo: null,
      inputData: null,
      EPaper: null,
    };
  },

  methods: {
    onReset() {

      this.user.id1 = "";
      this.user.id2 = "";
      this.user.id3 = "";
    },
    checkLoginData() {
      let msg = "";

      if (tools.isNullOrWhiteSpace(this.user.id1)) {
        msg = "學號";
      } else if (tools.isNullOrWhiteSpace(this.user.id2)) {
        msg = "學生篇密碼";
      }

      return msg;
    },

    login: function () {
      var vm = this;
      var msg = vm.checkLoginData();
      if (msg.length == 0) {
        var info = {
          text1: this.user.id1,
          text2: this.user.id2,
        };
      }
      this.$http
        .put("./WebApi/Common/Authorized", this.user)
        .then((response) => {
          vm.inputData = response.data;
          if (
            !tools.isNull(vm.inputData) &&
            vm.inputData.usrData.id === vm.user.id1
          ) {
            vm.memberShow = true;

            this.$store.dispatch("actionLogin2", vm.memberShow);
            this.$store.dispatch("actionLogin2Data", vm.inputData);
            vm.$router.push({ path: "StdLogin" });
          } else {
            tools.showAlert(vm, "danger", "請檢查帳號密碼或驗證碼是否輸入正確");
          }
        })
        .catch(function (error) {
          tools.showAlert(
            vm,
            "danger",
            "對不起, 登入失敗, 請檢查帳號密碼或驗證碼是否輸入正確"
          );
        });
    },
    getCaptcha: function () {
      var vm = this;
      this.$http
        .get("./WebApi/Common/GetCaptcha/")
        .then((response) => {
          vm.captchaInfo = response.data;
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },

  },
  beforeMount() {
    console.log("======beforeMount index  =====");
    this.getCaptcha();
  },
  created() {
    console.log("======created index  =====");


  },
};
</script>
<style scoped>
</style>
